<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span v-if="address">Actualizar dirección</span>
            <span v-else>Agregar dirección nueva</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <address-form :address="address" :supportLocalSave="supportLocalSave" @save="savedAddress" action="Usar esta dirección">
            <template v-slot:user v-if="user">
              <v-col xl="6" lg="6" md="6" sm="6" cols="12">
                <v-text-field class="mt-n4" v-model="user.first_name"
                  label="Nombre"
                  hint="Requerido"
                  :rules="[isRequired]"
                  persistent-hint
                  solo
                  dese>
                </v-text-field>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="6" cols="12">
                <v-text-field class="mt-n4" v-model="user.last_name"
                  label="Apellidos"
                  hint="Requerido"
                  :rules="[isRequired]"
                  persistent-hint
                  solo
                  dese>
                </v-text-field>
              </v-col>
            </template>
          </address-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AddressForm from '@/components/Address/AddressForm'
import { isRequired } from '@/shared/validations'

export default {
  name: 'AddressModal',
  components: {
    AddressForm
  },
  props: {
    address: {
      type: Object
    },
    supportLocalSave: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRequired,
      isOpen: false
    }
  },
  computed: {
    ...mapState('shared', ['error']),
    ...mapState('cart', ['user'])
  },
  methods: {
    ...mapMutations('cart', ['setUser']),
    openModal () {
      this.isOpen = true
    },
    closeModal () {
      this.isOpen = false
      this.$emit('close')
    },
    savedAddress (address) {
      if (!this.error) {
        this.closeModal()
      }

      this.setUser(this.user)
      this.$emit('save', address)
    }
  }
}
</script>

<style scoped>
  .light-text{
    font-size: 13px;
    color: #666;
    opacity: 0.7;
    line-height: 20px;
  }
</style>
